import React,{ useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
        Chip,
    Button
} from "@mui/material";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "config";
import StatusBadge from "components/badge/StatusBadge";
import { RxCross2 } from "react-icons/rx";
import CustomTable from "components/grid/CustomTable";
import ViewActionTracker from "view/actionTracker/ViewActionTracker";

const getStatusColor = (data) => {
    if (!data) return "purple";

    const status = (data.status || "").toLowerCase();
    const dueDate = data.dueDate ? new Date(data.dueDate) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate) dueDate.setHours(0, 0, 0, 0);


    // Case 1: In Progress & overdue
    if (status === "in progress" && dueDate && dueDate < today) {
        return { bg: "#FFD7D8", text: "#FF383C" };
    }

    // Case 2: In Progress & future due date
    if (status === "in progress" && dueDate && dueDate >= today) {
        return { bg: "orange", text: "white" };
    }

    // Case 3: Completed or Closed
    if (status === "completed" || status === "closed") {
        return { bg: "#E1FFBB", text: "#34A853" };
    }

    // Default
    return "purple";
};
const ViewDpItems = (props) => {
    const { open, handleClose, rowData, isLoading } = props;

    //action item related
    const [selectedAction, setSelectedAction] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    
    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        mb: 0.5,
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mb: 2,
    };

    const getAvatarColor = (text) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = text ? text.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const formatTime = (timeString) => {
        if (!timeString) return "N/A";
        return moment(timeString, "HH:mm:ss").format("hh:mm A");
    };
    const handleViewAction = (action) => {
        setSelectedAction(action);
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedAction(null);
    };
    const columns = (onView) => [
        {
            name: "ID",
            field: "customId",
            width: "50px"
        },
        {
            name: "Description",
            field: "description",
            width: "200px",
            sticky: true,
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {row?.description}
                </Box>
            ),
        },
        {
            name: 'Status',
            field: 'status',
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Assignee",
            field: "assignee",
            // width: "25%",
            renderer: (row) => (
                <>
                    {row?.assignedTo?.split(',')?.map((val, key) => (
                        <Typography key={key} sx={{ fontSize: "16px", fontWeight: 500, color: "#433F5E" }}>
                            {val}
                        </Typography>
                    ))}
                </>
            ),
        },
        {
            name: "Due Date",
            field: 'dueDate',
            renderer: (row) => (
                <>
                    {row?.revisedDueDate ?
                        <>
                            <Chip
                                label={moment.utc(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                sx={{
                                    textDecoration: "line-through",
                                    color: "#e51c1cff",
                                    backgroundColor: "#f5ccccff",
                                    fontWeight: 500,
                                    height: "20px",
                                    borderRadius: "5px",
                                    padding: "2px 6px",
                                    fontFamily: "Outfit",
                                    fontSize: "12px",
                                    marginRight: "5px",
                                }}
                            />
                            {row?.revisedDueDateHistory?.map((val, ind, arr) => {
                                const isLast = ind === arr.length - 1;
                                return (
                                    <Chip
                                        key={ind}
                                        label={moment(val).format(DEFAULT_DATE_FORMAT)}
                                        sx={{
                                            textDecoration: isLast ? "none" : "line-through",
                                            color: isLast ? "#34A853" : "#e51c1cff",
                                            backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
                                            fontWeight: 500,
                                            height: "20px",
                                            borderRadius: "5px",
                                            padding: "2px 6px",
                                            fontFamily: "Outfit",
                                            fontSize: "12px",
                                            marginRight: "5px",
                                        }}
                                    />
                                );
                            })}
                        </>
                        :
                        <>
                            {moment(row?.dueDate).isValid() ?
                                <Chip
                                    label={moment(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                    sx={{
                                        // textDecoration: "line-through",
                                        color: getStatusColor(row).text,
                                        backgroundColor: getStatusColor(row).bg,
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "5px",
                                        padding: "2px 6px",
                                        fontFamily: "Outfit",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                                : '-'
                            }
                        </>
                    }
                </>
            ),
        },
        {
            name: "",
            field: "",
            renderer: (row) => (
                <Button onClick={() => onView(row)}>
                    View
                </Button>
            ),
        },
    ];
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar
                        sx={{
                            width: 40,
                            height: 40,
                            bgcolor: getAvatarColor(rowData?.customId || ""),
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "bold",
                        }}
                    >
                        {rowData?.customId?.[0] || "D"}
                    </Avatar>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View DP Item Details
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Card
                            elevation={0}
                            sx={{
                                borderRadius: "3px",
                                border: "1px solid #e5e7eb",
                                backgroundColor: "#fff",
                                p: 2,
                            }}
                        >

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 1,
                                }}
                            >
                                <Typography sx={{
                                    fontWeight: 600,
                                    fontSize: "20px",
                                    fontFamily: "Outfit, sans-serif",
                                    color: "#0A0A0C"
                                }}>
                                    DP Item Information
                                </Typography>
                            </Box>

                            <Divider sx={{ mb: 3 }} />

                            <CardContent sx={{ pt: 0 }}>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12 }}>
                                        <Grid container spacing={1}>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>ID:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2, p: 0 }}>
                                                    <Typography sx={{
                                                        ...valueStyle,
                                                        color: "#1976D2",
                                                        fontWeight: 600
                                                    }}>
                                                        {rowData?.customId ?? "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Sub Project:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2, p: 0 }}>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.subProject ?? "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Material Procurement Status:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2, p: 0 }}>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.materialProcurementStatus ?? "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong> Status:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.status ?? "N/A"}
                                                </Typography>
                                            </Grid>


                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Material Description:</strong>
                                                </Typography>
                                                <Typography sx={{
                                                    ...valueStyle,
                                                    padding: "8px",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    minHeight: "40px",
                                                    lineHeight: "1.5"
                                                }}>
                                                    {rowData?.materialDescription ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>UOM:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.uom ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Quantity Required:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.quantityRequired ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Process Time:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.processTime ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Lead Time (Days):</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.leadTimeDays ?? "N/A"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Procurement Method:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.procurementMethod ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Source Department:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.sourceDepartment ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Procurement Owner:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.procurementOwner ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Requisition Date:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.requisitionDate ?
                                                            moment(rowData.requisitionDate).format("DD MMM YYYY") :
                                                            "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Planned date Of Tender Package:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>

                                                    {rowData?.plannedDateOfTenderPackage ?
                                                        moment(rowData.plannedDateOfTenderPackage).format("DD MMM YYYY") :
                                                        "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Planned LOI/WO/PO Release Date:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.plannedLoiWoPoReleaseDate ?
                                                            moment(rowData.plannedLoiWoPoReleaseDate).format("DD MMM YYYY") :
                                                            "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Vendor Name:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.vendorName ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>PO Date:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.poDate ?
                                                            moment(rowData.poDate).format("DD MMM YYYY") :
                                                            "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>PO Number:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.poNumber ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>PO Quantity:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.poQuantity ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>PO Rate:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.poRate ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>PO Value:</strong>
                                                </Typography>
                                                <Typography sx={valueStyle}>
                                                    {rowData?.poValue ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Planned Delivery Date:</strong>
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.plannedDeliveryDate ?
                                                            moment(rowData.plannedDeliveryDate).format("DD MMM YYYY") :
                                                            "N/A"}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 12 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Note:</strong>
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: "16px",
                                                    color: "#111827",
                                                    fontWeight: 500,
                                                    mb: 2,
                                                    fontFamily: "Outfit, sans-serif",
                                                    padding: "12px",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    borderLeft: "4px solid #4CAF50",
                                                    minHeight: "60px",
                                                    lineHeight: "1.5"
                                                }}>
                                                    {rowData?.note ?? "N/A"}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: "3px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fff",
                                    p: 2,
                                    mt: 1
                                }}
                            >
                                {/* Header */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                        Procurement Action Item
                                    </Typography>
                                </Box>

                                <Divider sx={{ mb: 2 }} />

                                <CardContent sx={{ pt: 0 }}>
                                    <Grid container spacing={2}>
                                        <Grid size={{ md: 12 }}>
                                            {/* data is dummy pls remove */}
                                            {/* <CustomTable columns={columns} data={[{
                                    description: '1. Maintain close coordination and regular communication with the Authority to monitor land acquisition progress. 2. Obtain early and clear timelines from the Authority for land handover and incorporate contingencies in the project schedule. 3. Plan phased construction activities to optimize progress on available land parcels',
                                    status:'Open',
                                    assignedTo:'Ashok'
                                }]} /> */}
                                            <CustomTable columns={columns(handleViewAction)} data={rowData?.projectActions || []} />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <ViewActionTracker
                                    open={isDialogOpen}
                                    handleClose={handleCloseDialog}
                                    rowData={selectedAction}  // or actionId={selectedAction?.id}
                                />

                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ViewDpItems;